
export const EMICalculator = (
  annualRate,
  Amount,
  Tenure
) => {

      let Rate = annualRate/ (12 * 100)
      let Monthly_EMI = Amount * Rate * (Math.pow(1 + Rate, Tenure) / (Math.pow(1 + Rate, Tenure) - 1));
    
      if (!isNaN(Monthly_EMI) && Monthly_EMI) {
       let num;
        try {
        num = Monthly_EMI
          .toFixed(2)
          
        } catch {
        num = Monthly_EMI;
        }
      return num;
    }
    return Monthly_EMI ;
  };
  